import React from 'react';
import { Row, Col, Icon, Input } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AppWrappperHOC } from '../../../Root/HOC';
import LandingContainer from '../../../../components/LandingContainer';
import Journey from '../../../../containers/NewLanding/Journey';
import endPoints from '../../../../config/endPoints';
import { constants } from '../../../../devUtils';

const StyledNewsInternal = styled.section`
  .image-grayscale{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  p{
    color: ${({ theme }) => theme.LandingBlack};
  }
  .bg-white{
    background: ${({ theme }) => theme.whiteColor};
    box-shadow: 3px 3px 20px #24415D0F;
    border-radius: 10px;
    padding: 15px;
    p{
      padding: 5px 0px;
      border-bottom: 1px solid ${({ theme }) => theme.webGray};
    }
  }
`;

function NewsView() {
  return (
    <StyledNewsInternal>
      <div className="gray-greadient">
        <section className="padding-tb-5">
          <LandingContainer>
            <Row align="top" type="flex" justify="start" gutter={32}>
              <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                <Link to={constants.LINK_CONTACTUS}><Icon type="left" /> back to News</Link>
                <h1>How has the Coronavirus pandemic accelerated digitization</h1>
                <p>Posted on September 2, 2020</p>
              </Col>
              <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                <Input placeholder="Search" className="margin-t-1" />
              </Col>
              <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                <img
                  src={endPoints.NEWS_INTERNAL_LANDING_IMAGE.URL}
                  alt={endPoints.NEWS_INTERNAL_LANDING_IMAGE.ALT}
                  className="width-100 image-grayscale"
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                <h1 className="font-18">Recent News</h1>
                <div className="bg-white">
                  <p>How has the Coronavirus pandemic accelerated digitization</p>
                  <p>How has the Coronavirus pandemic accelerated digitization</p>
                  <p>How has the Coronavirus pandemic accelerated digitization</p>
                  <p>How has the Coronavirus pandemic accelerated digitization</p>
                  <p>How has the Coronavirus pandemic accelerated digitization</p>
                  <p>How has the Coronavirus pandemic accelerated digitization</p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                <h1 className="font-18">“Necessity is the Mother of Invention”</h1>
                <p>The coronavirus pandemic has proved this saying to be true. The world has begun to find new ways of functioning to adapt to the ever-changing global crisis. The businesses, in particular, have been the most effected. But they have found new innovative ways to keep going which in fact, are turning out to be efficient solutions. In the pre-pandemic world, people in some sectors of the society weren’t as accustomed to a digitized world as they are today. In fact, some people didn’t even believe in digitization. But now, numerous businesses took to online platforms to carry out their daily operations and along the process, have created awareness as to how convenient such platforms can be. Some sectors of the economy, in particular, have been more affected by this pandemic. Let’s look at these in detail and how they have changed over the past several months:</p>
                <h1 className="font-18">Banking industry</h1>
                <p>The concept of banking has changed drastically all due to COVID-19. Earlier, banking apps weren’t as commonly used, and people had to personally go to a branch for a majority of purposes. But ever since the pandemic hit, banks as well as customers had to quickly adapt to the digital world. Contactless payments have increased in the recent times and the use of apps like Google pay and Paytm has also shot up.</p>
                <p>In the pre-pandemic era, not much of importance was given to digitized banking. But now, people are more aware of the new technologies and are using them to the maximum extent possible. These new digital platforms are indeed good for both, the banks and its customers. Now banking apps are being used not just for checking balances but also for various other purposes. Banks are evolving their methods of customer satisfaction and finding new ways to improve their services.</p>
                <h1 className="font-18">Health and wellness</h1>
                <p>The COVID-19 has prompted a new level of hygiene all over the world. People have become more health conscious than ever and are taking steps towards a healthy lifestyle. They are avoiding going to clinics and hospitals for little things and are turning a majority of health needs virtual. Doctor appointments have also now become zoom meetings.</p>
                <p>Apps like Aarogya Setu have become increasingly popular to help people be aware of any infected cases around them. Gyms and other fitness centers have also come up with virtual training apps to encourage people to stay home and be healthy. It is astonishing to see the new innovative methods people are resorting to stay safe and practice social distancing.</p>
                <h1 className="font-18">Education</h1>
                <p>The education system has taken a whole new turn in 2020.Virtual classes for students of all ages have become a part and parcel of life. There is no more of sitting in a classroom with peers and teachers physically presenting the material. This has been difficult to adjust for students as well as teachers. The EdTech sector has seen a rapid growth ever since lockdown was announced in India. It was high time that the Indian education system saw some boost in its educational technology and this pandemic ensured of it. Private institutions have resorted to online learning in order to continue the academic year without any pauses. Online coaching classes for competitive exams like GRE, GMAT, etc. have existed in the past but their demand has increased in recent times because more students are resorting to online platforms to continue their education.</p>
                <p>However, not every student in India has access to a smartphone or laptop. Students, especially in rural areas, face internet connectivity problems and struggle to keep up with classes. Moreover, electricity issues also exist in these areas. A majority of students in rural areas are enrolled in government schools which do not provide digital learning. Therefore, a progressive model for education is being implemented in urban areas but students in many parts of India are still facing difficulties in having access to quality education. Although, I am positive that this issue will be taken off by the government and entrepreneurs in the coming future.</p>
                <p>In Conclusion… Nobody likes change, but it is inevitable. Transitioning and adjusting to a new way of life is daunting. Millions of people are out of jobs and many industries have come crashing down. There are disadvantages of people not being able to physically interact in this modern-day digitized world but on the bright side, the pandemic has made us switch to a more efficient and smarter way of functioning. Digitization has given us new perspectives and broadened our horizons. It is progressive and the sooner people adapt to it, the better.</p>
              </Col>
              <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                <h1 className="font-18">Follow Us</h1>
                <div className="bg-white">
                  <h2 className="font-14">Contact Media</h2>
                  <p>Media@Zaggle.in</p>
                  <h2 className="font-14">Follow Us</h2>
                </div>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <Journey />
      </div>
    </StyledNewsInternal>
  );
}

const component = AppWrappperHOC(NewsView);

export { NewsView };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Press/NewsInternalPage/index.js